const initState = {
  siteList: [],
  currentProject: {},
  machineGroupOptions: [],
  professionOptions: [],
}
const Sites = {
  namespaced: true,
  state: {
    ..._.cloneDeep(initState)
  },
  mutations: {
    resetState(state) {
      _.assign(state, initState)
    },
    updateState(state, { payload }) {
      _.assign(state, payload)
    },
    siteList(state, payload) {
      _.assign(state, {
        siteList: payload,
      })
    },
    currentProject(state, payload) {
      _.assign(state, {
        currentProject: payload,
      })
    },
    machineGroupOptions(state, payload) {
      _.assign(state, {
        machineGroupOptions: payload,
      })
    },
    professionOptions(state, payload) {
      _.assign(state, {
        professionOptions: payload,
      })
    },
  },
  getters: {
    siteList(state) {
      return state.siteList
    },
    currentProject(state) {
      return state.currentProject
    },
    machineGroupOptions(state) {
      return state.machineGroupOptions
    },
    professionOptions(state) {
      return state.professionOptions
    },
  },
  actions: {
    siteList({ commit }, payload) {
      commit('siteList', payload)
    },
    currentProject({ commit }, payload) {
      commit('currentProject', payload)
    },
    machineGroupOptions({ commit }, payload) {
      commit('machineGroupOptions', payload)
    },
    professionOptions({ commit }, payload) {
      commit('professionOptions', payload)
    }
  },
}

export default Sites
